import React, { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { FileUpload } from '../../../components/form-controls/FileUpload';
import { useGroupContext } from '../../../context/GroupContext';

export const GroupFileUpload = () => {
  const { watch, setValue } = useFormContext();
  const { type } = useGroupContext();

  const handleFileChange = useCallback(
    (file) => {
      if (file.length && file[0] instanceof File) {
        setValue('logo', file);
      } else {
        setValue('logo', undefined);
      }
    },
    [setValue]
  );

  return (
    <FileUpload
      label="JPG format supported: up to 4 MB"
      name="groupLogo"
      disabled={type === 'inactive'}
      value={watch('logo')}
      removeLogo={handleFileChange}
      onChange={handleFileChange}
      onBlur={handleFileChange}
    />
  );
};
